import { Injectable } from '@angular/core';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';

import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class PageProgressService {
    public showPageProgress = new BehaviorSubject<boolean>(false);

    constructor(router: Router) {
        router.events.subscribe((event) => {
            if (event instanceof NavigationStart) {
                this.showPageProgress.next(true);
            } else if (event instanceof NavigationEnd) {
                this.showPageProgress.next(false);
            }
        });
    }

    public show = () => {
        this.showPageProgress.next(true);
    }

    public hide = () => {
        this.showPageProgress.next(false);
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/page-progress.service.ts